const authEnvValues = {
  NEXT_PUBLIC_API_GATEWAY_URL: process.env.NEXT_PUBLIC_API_GATEWAY_URL,
  NEXT_PUBLIC_API_GATEWAY_STAGE: process.env.NEXT_PUBLIC_API_GATEWAY_STAGE,
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_AUTH_URL: process.env.NEXT_PUBLIC_AUTH_URL,
  NEXT_PUBLIC_COGNITO_BASE_URL: process.env.NEXT_PUBLIC_COGNITO_BASE_URL,
  /** Hosted UI hostname only (no scheme). Used if `NEXT_PUBLIC_COGNITO_BASE_URL` is unset. */
  NEXT_PUBLIC_COGNITO_DOMAIN: process.env.NEXT_PUBLIC_COGNITO_DOMAIN,
  NEXT_PUBLIC_COGNITO_CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
  NEXT_PUBLIC_COGNITO_USER_POOL_ID: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
} as const

function readEnv(name: keyof typeof authEnvValues): string | null {
  const value = authEnvValues[name]?.trim()
  return value ? value : null
}

function resolveCognitoBaseUrl(): string | null {
  const explicit = readEnv('NEXT_PUBLIC_COGNITO_BASE_URL')
  if (explicit) {
    return explicit
  }

  const domain = readEnv('NEXT_PUBLIC_COGNITO_DOMAIN')
  if (!domain) {
    return null
  }

  const host = domain.replace(/^https?:\/\//i, '').replace(/\/+$/, '')
  return host ? `https://${host}` : null
}

export const authEnv = {
  apiGatewayUrl: readEnv('NEXT_PUBLIC_API_GATEWAY_URL'),
  apiGatewayStage: readEnv('NEXT_PUBLIC_API_GATEWAY_STAGE'),
  appUrl: readEnv('NEXT_PUBLIC_APP_URL'),
  authApiUrl: readEnv('NEXT_PUBLIC_AUTH_URL'),
  cognitoBaseUrl: resolveCognitoBaseUrl(),
  cognitoClientId: readEnv('NEXT_PUBLIC_COGNITO_CLIENT_ID'),
  cognitoUserPoolId: readEnv('NEXT_PUBLIC_COGNITO_USER_POOL_ID'),
} as const

export const cognitoConfig = {
  clientId: authEnv.cognitoClientId,
  baseUrl: authEnv.cognitoBaseUrl,
  userPoolId: authEnv.cognitoUserPoolId,
} as const
